import { isPointOnSegment } from "."
import type { Point2d } from ".."
import type { Edge2dComputed } from "../../mesh"

// To find orientation of ordered triplet (p, q, r).
// The function returns following values
// 0 --> p, q and r are collinear
// 1 --> Clockwise
// 2 --> Counterclockwise
type Orientation = `Clockwise` | `Collinear` | `Counterclockwise`
const getOrientation = (p: Point2d, q: Point2d, r: Point2d): Orientation => {
  // See https://www.geeksforgeeks.org/orientation-3-ordered-points/
  // for details of below formula.
  const val = (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y)

  if (val === 0) return `Collinear`

  return val > 0 ? `Clockwise` : `Counterclockwise`
}

type DoSegmentsIntersect = (a: Edge2dComputed, b: Edge2dComputed) => boolean

export const doSegmentsIntersect: DoSegmentsIntersect = (e1, e2) => {
  const a = e1.p1
  const b = e1.p2
  const c = e2.p1
  const d = e2.p2

  const abc = getOrientation(a, b, c)
  const abd = getOrientation(a, b, d)
  const cda = getOrientation(c, d, a)
  const cdb = getOrientation(c, d, b)

  const doIntersect = abc !== abd && cda !== cdb

  if (doIntersect) return true

  if (abc === `Collinear` && isPointOnSegment(c, { p1: a, p2: b })) return true

  if (abd === `Collinear` && isPointOnSegment(d, { p1: a, p2: b })) return true

  if (cda === `Collinear` && isPointOnSegment(a, { p1: c, p2: d })) return true

  if (cdb == `Collinear` && isPointOnSegment(b, { p1: c, p2: d })) return true

  return false
}

// export const doSegmentsIntersect: DoSegmentsIntersect = (e1, e2) =>
//   Boolean(whereDoSegmentsIntersect(e1, e2))
